<template>
  <v-row no-gutters>
    <v-col cols="12">
      <BaseToolbar
        :title="$t('subscriptions.details.details')"
        @close="$emit('close')"
        type-title="icon"
        :primaryColor="true"
        :hideVideo="true"
      />
      <v-card
        flat
        color="grey lighten-3"
        height="100vh"
        style="overflow-y:auto;"
      >
        <!--------------------------------------------------------->
        <!-- TITLE ------------------------------------------------>
        <!--------------------------------------------------------->
        <v-card-title
          ref="card-member-contain-subscription"
          v-if="subscription"
          class="py-5"
        >
          <template>
            <v-container>
              <v-card class="" style="position: relative;">
                <v-card-text class="text-center">
                  <div style="position: absolute; top: 10px; right: 10px;">
                    <v-chip
                      ref="chip-subscription-status"
                      :text-color="
                        [2, 3, 6, 18].includes(subscription.state)
                          ? '#27AE60'
                          : subscription.state === 4
                          ? '#4F4F4F'
                          : 'red accent-4'
                      "
                      :color="
                        [2, 3, 6, 18].includes(subscription.state)
                          ? 'rgb(39,174,96, 0.12)'
                          : subscription.state === 4
                          ? 'rgba(0, 0, 0, 0.07)'
                          : 'red lighten-5'
                      "
                      class="mx-2"
                      small
                    >
                      <span class="caption text-uppercase">
                        {{
                          [3, 6].includes(subscription.state)
                            ? $t("profile.profile.active")
                            : subscription.state === 1
                            ? $t("transactions.details.cancelled")
                            : subscription.state === 2
                            ? $t("subscriptions.status.success")
                            : subscription.state === 4
                            ? $t("transactions.status.pending")
                            : subscription.state === 18
                            ? $t("subscriptions.status.pre_notified")
                            : $t("transactions.dashboard.failed")
                        }}
                      </span>
                    </v-chip>
                  </div>
                  <div class="headline font-weight-bold">
                    {{ $t("subscriptions.details.transactionId") }}
                  </div>
                  <div class="title primary--text ">
                    {{ subscription.transaction_gateway_code }}
                  </div>
                </v-card-text>
              </v-card>
            </v-container>
          </template>
          <v-spacer />
          <v-menu
            v-if="
              subscription.gateway.gateway.info.includes('EDIT_SUBSCRIPTION') ||
                (subscription.state !== 1 &&
                  subscription.gateway.gateway.info.includes(
                    'CANCEL_SUBSCRIPTION'
                  )) ||
                subscription.gateway.gateway.info.includes(
                  'MANUAL_SUBSCRIPTION'
                ) ||
                (subscription.gateway.gateway.info.includes(
                  'AFRUS_ENGINE_RECURRENT_PAYMENT'
                ) &&
                  subscription.subscription_afrus_engine)
            "
            offset-y
            left
            nudge-bottom="10px"
          >
            <v-list> </v-list>
          </v-menu>
        </v-card-title>
        <v-card-text ref="card-member-lastsubscription" v-if="subscription">
          <v-row>
            <!--------------------------------------------------------->
            <!-- LAST SUBSCRIPTION ------------------------------------>
            <!--------------------------------------------------------->
            <v-col cols="3">
              <v-card
                :color="
                  [2, 3, 7, 18].includes(subscription.state)
                    ? '#27AE60'
                    : '#BDBDBD'
                "
              >
                <v-card-text class="white--text pa-5">
                  <div class="title">
                    {{ $t("subscriptions.details.last_donation") }}
                  </div>
                  <div
                    ref="member-subscription-diferent-currency"
                    v-if="subscription.gateway.currency.code"
                    class="headline"
                  >
                    {{ subscription.gateway.currency.symbol }}
                    {{ subscription.amount }}
                    {{ subscription.gateway.currency.code }}
                  </div>
                  <div
                    ref="member-subscription-conversion-amount"
                    class="display-1"
                  >
                    <!-- {{ symbolCurrency }} -->
                    {{ subscription.conversion_amount }}
                    <!-- {{ codeCurrency }} -->
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <!--------------------------------------------------------->
            <!-- TOTAL DONATION --------------------------------------->
            <!--------------------------------------------------------->
            <v-col cols="4">
              <v-card
                :color="
                  subscription.state === 3 ||
                  subscription.state === 2 ||
                  subscription.state === 18
                    ? '#1976D2'
                    : '#BDBDBD'
                "
              >
                <v-card-text class="white--text pa-5">
                  <div class="title">
                    {{ $t("transactions.details.total_donations") }}
                  </div>
                  <div
                    ref="member-totaldonation-diferent-currency"
                    v-if="subscription.gateway.currency.code"
                    class="headline"
                  >
                    {{ subscription.gateway.currency.symbol }}
                    {{ subscription.totalOrginalCurrency }}
                    {{ subscription.gateway.currency.code }}
                  </div>
                  <div
                    ref="member-totaldonation-total-charges"
                    class="display-1"
                  >
                    {{ subscription.totalChargesConversionAmount }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <!--------------------------------------------------------->
            <!-- DETAILS ---------------------------------------------->
            <!--------------------------------------------------------->
            <v-col cols="5">
              <v-card>
                <v-card-text class="py-0">
                  <v-row>
                    <!--------------------------------------------------------->
                    <!-- PAYMENT METHOD --------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col
                      :cols="subscription.subscription_afrus_engine ? 4 : 6"
                      class="border-right"
                    >
                      <v-card height="80px" flat>
                        <div class="body-2 grey--text">
                          {{ $t("subscriptions.details.paymentMethod") }}
                        </div>
                        <div
                          ref="subscription-payment-method"
                          :class="
                            subscription.state === 3 || subscription.state === 2
                              ? 'text--darken-3'
                              : ''
                          "
                          class="title grey--text"
                        >
                          <v-icon>
                            {{
                              subscription.payment_method === 1
                                ? "credit_card"
                                : "account_balance"
                            }}
                          </v-icon>
                          {{
                            subscription.payment_method === 1
                              ? $t("transactions.details.creditCard")
                              : subscription.payment_method === 2
                              ? $t("transactions.details.bank_account")
                              : $t("transactions.details.ticket")
                          }}
                        </div>
                      </v-card>
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- INTERVAL (ONLY AFRUS ENGINE) --------------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col
                      v-if="subscription.subscription_afrus_engine"
                      cols="4"
                      class="border-right"
                    >
                      <v-card height="80px" flat>
                        <div class="body-2 grey--text">
                          {{ $t("subscriptions.details.interval") }}
                        </div>
                        <div
                          ref="subscription-frecuency"
                          :class="
                            subscription.state === 3 || subscription.state === 2
                              ? 'text--darken-3'
                              : ''
                          "
                          class="title grey--text"
                        >
                          {{
                            subscription.frequency
                              ? subscription.frequency.name === "Monthly"
                                ? $t("subscriptions.frequency.monthly")
                                : $t("subscriptions.frequency.Yearly")
                              : $t("subscriptions.frequency.monthly")
                          }}
                        </div>
                      </v-card>
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- DONATION PAID ---------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col
                      :cols="subscription.subscription_afrus_engine ? 4 : 6"
                    >
                      <v-card height="80px" flat>
                        <div class="body-2 grey--text">
                          {{ $t("subscriptions.details.donation_paid") }}
                        </div>
                        <div
                          ref="subscription-donation-paid"
                          :class="
                            subscription.state === 3 || subscription.state === 2
                              ? 'text--darken-3'
                              : ''
                          "
                          class="title grey--text"
                        >
                          {{
                            $t("transactions.details.efficiency", {
                              success: subscription.successfulCharges,
                              attempts: subscription.attemptedCharges
                            })
                          }}
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-divider />
                  <v-row>
                    <!--------------------------------------------------------->
                    <!-- INTERVAL --------------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col
                      v-if="!subscription.subscription_afrus_engine"
                      cols="6"
                      class="border-right"
                    >
                      <v-card height="80px" flat>
                        <div class="body-2 grey--text">
                          {{ $t("subscriptions.details.interval") }}
                        </div>
                        <div
                          ref="subscription-frecuency"
                          :class="
                            subscription.state === 3 || subscription.state === 2
                              ? 'text--darken-3'
                              : ''
                          "
                          class="title grey--text"
                        >
                          {{
                            subscription.frequency
                              ? subscription.frequency.name === "Monthly"
                                ? $t("subscriptions.frequency.monthly")
                                : $t("subscriptions.frequency.Yearly")
                              : $t("subscriptions.frequency.monthly")
                          }}
                        </div>
                      </v-card>
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- GATEWAY ---------------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col
                      :class="
                        subscription.subscription_afrus_engine
                          ? 'border-right'
                          : ''
                      "
                      cols="6"
                    >
                      <v-card height="80px" flat>
                        <div class="body-2 grey--text">
                          {{ $t("subscriptions.details.gateway") }}
                        </div>
                        <div class="d-flex justify-center align-center">
                          <v-img
                            :src="
                              require(`@/assets/svg/gateways/${getLogoPath(
                                subscription.gateway.gateway.name
                              )}`)
                            "
                            max-height="60px"
                            min-height="60px"
                            contain
                          />
                        </div>
                      </v-card>
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- BY AFRUS ENGINE -------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col
                      v-if="subscription.subscription_afrus_engine"
                      cols="6"
                    >
                      <v-card height="80px" flat>
                        <div class="body-2 grey--text">
                          {{ $t("transactions.details.by_afrus_engine") }}
                        </div>
                        <div class="d-flex justify-center align-center mt-2">
                          <!-- <v-img
                                :src="require(`@/assets/img/afrus_logo_2.png`)"
                                max-height="35px"
                                min-height="35px"
                                contain
                              /> -->
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12">
              <v-card>
                <v-card-text>
                  <v-row dense>
                    <!--------------------------------------------------------->
                    <!-- FIRST DONATION --------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col cols="2">
                      <v-row dense>
                        <v-col cols="12" class="d-flex justify-center">
                          <div class="subtitle-2 grey--text">
                            {{ $t("subscriptions.details.first_donation") }}
                          </div>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center">
                          <v-chip text-color="grey darken-4">
                            <v-icon class="mx-1" color="grey darken-4">
                              event
                            </v-icon>
                            <span
                              ref="subscription-first-donation"
                              v-if="subscription.dateFirstCharge"
                            >
                              {{ subscription.dateFirstCharge | moment("ll") }}
                            </span>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      :cols="
                        subscription.state === 3 || subscription.state === 2
                          ? 3
                          : 8
                      "
                      class="d-flex align-center"
                    >
                      <v-divider class="grey darken-4 mt-5" />
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- LAST DONATION ---------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col cols="2">
                      <v-row dense>
                        <v-col cols="12" class="d-flex justify-center">
                          <div class="subtitle-2 grey--text">
                            {{ $t("subscriptions.details.last_donation") }}
                          </div>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center">
                          <v-chip
                            :color="
                              subscription.state === 3 ||
                              subscription.state === 2
                                ? 'green lighten-4'
                                : undefined
                            "
                            :text-color="
                              subscription.state === 3 ||
                              subscription.state === 2
                                ? 'green darken-2'
                                : undefined
                            "
                          >
                            <v-icon
                              :color="
                                subscription.state === 3 ||
                                subscription.state === 2
                                  ? 'green darken-2'
                                  : 'grey darken-4'
                              "
                              class="mx-1"
                            >
                              event
                            </v-icon>
                            <span
                              ref="subscription-last-donation"
                              v-if="subscription.dateLastCharge"
                            >
                              {{ subscription.dateLastCharge | moment("ll") }}
                            </span>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      v-if="
                        subscription.state === 3 || subscription.state === 2
                      "
                      cols="3"
                      class="d-flex align-center"
                    >
                      <v-divider class="grey darken-4 mt-5" />
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- NEXT DONATION ---------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col
                      v-if="
                        subscription.state === 3 || subscription.state === 2
                      "
                      cols="2"
                    >
                      <v-row dense>
                        <v-col cols="12" class="d-flex justify-center">
                          <div class="subtitle-2 grey--text">
                            {{ $t("subscriptions.details.next_donation") }}
                          </div>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-center">
                          <v-chip
                            ref="subscription-next-donation"
                            color="blue lighten-4"
                            text-color="blue darken-2"
                          >
                            <v-icon class="mx-1" color="blue darken-2">
                              event
                            </v-icon>
                            {{
                              subscription.next_payment_date
                                ? this.$moment
                                    .utc(subscription.next_payment_date)
                                    .format("ll")
                                : ""
                            }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <!-------------------------------------------------------------------->
            <!-- DETAILS --------------------------------------------------------->
            <!-------------------------------------------------------------------->
            <v-col cols="8">
              <v-card>
                <v-card-title class="title">
                  {{ $t("subscriptions.details.campaignDetails") }}
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <v-row dense>
                    <!--------------------------------------------------------->
                    <!-- CREATED AT ------------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col cols="3">
                      <div class="subtitle-2 primary--text">
                        {{ $t("subscriptions.created_at") }}
                      </div>
                    </v-col>
                    <v-col cols="9">
                      <div ref="subscription-create-at" class="body-2">
                        {{ subscription.created_at | moment("LLL") }}
                      </div>
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- GATEWAY ID ------------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col cols="3">
                      <div class="subtitle-2 primary--text">
                        {{ $t("subscriptions.details.gatewayId") }}
                      </div>
                    </v-col>
                    <v-col cols="9">
                      <div ref="subscription-gateway-code" class="body-2">
                        {{ subscription.transaction_gateway_code }}
                      </div>
                    </v-col>
                    <!--------------------------------------------------------->
                    <!--CAMPAIGN ---------------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col cols="3" v-if="subscription.campaign">
                      <div class="subtitle-2 primary--text">
                        {{ $t("subscriptions.details.campaign") }}
                      </div>
                    </v-col>
                    <v-col cols="9">
                      <div ref="subscription-campaign-name" class="body-2">
                        {{
                          subscription.campaign
                            ? subscription.campaign.name
                            : null
                        }}
                      </div>
                    </v-col>
                    <!--------------------------------------------------------->
                    <!-- FORM ------------------------------------------------->
                    <!--------------------------------------------------------->
                    <v-col cols="3">
                      <div class="subtitle-2 primary--text">
                        {{ $t("transactions.details.form") }}
                      </div>
                    </v-col>
                    <v-col cols="9">
                      <div ref="subscription-form-name" class="body-2">
                        {{ subscription.form ? subscription.form.name : "" }}
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            <div>
                              {{ $t("transactions.details.sourceDetails") }}
                            </div>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content class="pa-0">
                            <v-divider />
                            <v-container class="px-5">
                              <v-row dense> </v-row>
                            </v-container>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <!------------------------------------------------------------------------>
            <!-- GATEWAY DETAILS ----------------------------------------------------->
            <!------------------------------------------------------------------------>
            <v-col cols="4">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-card>
                    <v-card-title class="title">
                      {{
                        $t("transactions.details.gateway_details", {
                          gateway: subscription.gateway.gateway.name
                        })
                      }}
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                      <v-row dense>
                        <!--------------------------------------------------------->
                        <!-- PAYMENT METHOD ID ------------------------------------>
                        <!--------------------------------------------------------->
                        <v-col cols="6">
                          <div class="subtitle-2 primary--text">
                            {{ $t("transactions.details.paymentMethodId") }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div
                            ref="subscription-payment-method-id"
                            class="body-2"
                          >
                            {{ subscription.payment_method }}
                          </div>
                        </v-col>
                        <!--------------------------------------------------------->
                        <!-- GATEWAY CODE ----------------------------------------->
                        <!--------------------------------------------------------->
                        <v-col cols="6">
                          <div class="subtitle-2 primary--text">
                            {{ $t("transactions.details.subscriptionId") }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div
                            ref="subscription-gateway-code-id"
                            class="body-2"
                          >
                            {{ subscription.transaction_gateway_code }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" class="mt-4">
                  <v-card>
                    <v-card-title class="title">
                      {{ $t("subscriptions.details.client_details") }}
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                      <v-row dense>
                        <!--------------------------------------------------------->
                        <!-- CUSTOMER ID ------------------------------------------>
                        <!--------------------------------------------------------->
                        <v-col cols="6">
                          <div class="subtitle-2 primary--text">
                            {{ $t("subscriptions.details.customerId") }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div ref="subscription-customer-id" class="body-2">
                            {{ subscription.lead.id }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="subtitle-2 primary--text">
                            {{ $t("subscriptions.details.customerName") }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div ref="subscription-customer-id" class="body-2">
                            {{
                              subscription.lead.first_name +
                                " " +
                                subscription.lead.last_name
                            }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col
                  v-if="Object.keys(subscription.events)[0]"
                  cols="12"
                  class="pt-5"
                >
                  <v-card>
                    <v-card-title class="title">
                      {{ $t("campaigns.details.timeline.title") }}
                    </v-card-title>
                    <v-divider />
                    <v-card-text style="overflow-y: auto; max-height: 400px;">
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import donationMixin from "@/mixins/donations";
import BaseToolbar from "@/components/BaseToolbar";
export default {
  name: "SubscriptionDetails",
  components: { BaseToolbar },
  mixins: [donationMixin],
  props: {
    subscription: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      radioSubscription: "immediately",
      dialog: false,
      eventSelected: null
    };
  },
  computed: {},
  methods: {
    getLogoPath(gateway) {
      if (gateway === "Stripe") {
        return "stripe.svg";
      }
      if (gateway === "Pagar.me") {
        return "pagarme.svg";
      }
      if (gateway === "DuPay") {
        return "dupay.svg";
      }
      if (gateway === "UNICEF") {
        return "unicef.svg";
      }
      if (gateway === "Braintree") {
        return "braintree.svg";
      }
      if (gateway === "Bakery") {
        return "payments-way.png";
      }
      if (gateway === "Mercado Pago") {
        return "mercadopago.svg";
      }
      if (gateway === "Débito Recurrente Bancario") {
        return "ach.png";
      }
      if (gateway === "Getnet") {
        return "getnet.svg";
      }
      if (gateway === "Niubiz") {
        return "niubiz.png";
      }
      if (gateway === "PlacetoPay") {
        return "placetopay.png";
      }
      if (gateway === "SDS") {
        return "ach.png";
      }
      if (gateway === "NMI") {
        return "nmi.png";
      }
      if (gateway === "Paypal") {
        return "paypal.svg";
      }
      if (gateway === "Conekta") {
        return "conekta.svg";
      }
      if (gateway === "Wompi") {
        return "wompi.svg";
      }
      return "ach.png";
    }
  }
};
</script>

<style>
.light-black {
  color: #828282;
}
.border-right {
  border-right: 1px solid #e0e0e0;
}
</style>
